export default "assets/images/icons/parcellaire-80a172b1.svg";